import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  RdsProgressSpinnerComponent,
  RdsSwitchComponent,
} from '@rds/angular-components';

import {
  BookingStatsComponent,
  BookingsTableComponent,
  ChartDataService,
  GroupedBarChartComponent,
  PieChartComponent,
  ViewportService,
} from '@bookly/shared';

@Component({
  selector: 'bus-charts',
  imports: [
    GroupedBarChartComponent,
    PieChartComponent,
    RdsProgressSpinnerComponent,
    BookingStatsComponent,
    FormsModule,
    BookingsTableComponent,
    RdsSwitchComponent,
  ],
  templateUrl: './charts.component.html',
  styleUrl: './charts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartsComponent implements OnInit {
  readonly #chartService = inject(ChartDataService);
  readonly #viewport = inject(ViewportService);
  protected readonly countPerMonthRT = this.#chartService.countPerMonthRT;
  protected readonly averagePerWeekday = this.#chartService.averagePerWeekday;
  protected readonly averagePeoplePerRoomType =
    this.#chartService.averagePeoplePerRoomType;
  protected readonly countPerStatus = this.#chartService.countPerStatus;
  protected readonly isLoading = this.#chartService.isDataLoading;
  protected readonly bookingsData = this.#chartService.chartData;
  // Seeded from the viewport, then owned by the user via the ngModel switches.
  protected showLegend = !this.#viewport.isMobile();
  protected showValues = !this.#viewport.isMobile();

  ngOnInit(): void {
    this.#chartService.loadChartData().subscribe();
  }
}
